<template>
  <div class="basket">
    <slideout-panel ref="basket-pane"></slideout-panel>
  </div>
</template>

<script>
/* global gtag */

import Vue from "vue";
import VueSlideoutPanel from "vue2-slideout-panel";

import BasketPane from "@/components/BasketPane";

Vue.use(VueSlideoutPanel);

export default {
  data() {
    return {
      basketPanel: false,
      shownCount: 0,
    };
  },
  props: {
    isCheckout: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  computed: {
    gtag_items() {
      return this.$store.getters["basket/gtag_items"];
    },
    totals() {
      return this.$store.state.basket.totals;
    },
  },
  mounted() {
    window.addEventListener("basket-show", this.showBasket);
    window.addEventListener("basket-hide", this.hideBasket);
    window.addEventListener("basket-expired", this.basketExpired);
  },
  destroyed() {
    window.removeEventListener("basket-show", this.showBasket, false);
    window.removeEventListener("basket-hide", this.hideBasket, false);
    window.removeEventListener("basket-expired", this.basketExpired, false);
  },
  methods: {
    showBasket(evt) {
      this.shownCount++;

      if (this.basketPanel) {
        this.basketPanel.show({
          props: {
            isCheckout: this.isCheckout,
            scrollToProduct: evt ? evt.detail.scrollToProduct : null,
          },
        });
      } else {
        this.basketPanel = this.$showPanel({
          component: BasketPane,
          openOn: "right",
          width: "430px",
          props: {
            isCheckout: this.isCheckout,
            scrollToProduct: evt ? evt.detail.scrollToProduct : null,
          },
        });
      }

      gtag("event", "view_cart", {
        currency: "GBP",
        value: this.totals.total,
        items: this.gtag_items,
      });
    },
    hideBasket() {
      if (this.shownCount !== 0) {
        this.basketPanel.hide();
        this.shownCount--;
      }

      // panel1Handle.promise
      //   .then(result => {

      //   });
    },
    basketExpired() {
      this.$store.commit("basket/reset");
    },
  },
};
</script>